import Autocomplete from '@mui/material/Autocomplete';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';
import { ISelectableValue } from '../../model/measure';
import { FormControl, FormHelperText } from '@mui/material';
import mikeSharedTheme from '../../styles/mikeSharedTheme';
import { helperTextPlaceHolderStyle } from '../../styles/sharedDropdownStyles';

interface IProps  {
  options: Array<ISelectableValue>;
  autoComplete?: string;
  autoFocus?: boolean;
  disabled?: boolean; 
  fullWidth?: boolean; 
  label: string;
  name: string;  
  onChange?: (e: React.ChangeEvent, param: string) => void;
  required?: boolean;
  rows?: number;
  type?: string; 
  addPlaceHolder: boolean;
  slotProps?: any;
}


const AutoListbox = (props: IProps) => {
  const {  
    autoFocus,
    disabled, 
    fullWidth,  
    name,   
    onChange,   
    slotProps,
    options
  } = props;

  const [field, meta ] = useField(name);  

  const onInputChanged = (event, selection: any) => {   
    if (onChange) {
      onChange(event, selection ? selection.id : null);
    }    
  }; 

  return (
    <FormControl 
      sx={{ p: 0, minWidth: mikeSharedTheme.spacing(15) }}
      disabled={disabled}
      error={meta.error ? true : false}
      fullWidth={fullWidth}
      size="small"
      variant={'filled'}    
    >
    <Autocomplete
      slotProps={slotProps}
      style={{ minWidth: '8em', whiteSpace: 'nowrap' }}
      options={options}
      autoFocus={autoFocus}
      disabled={disabled}    
      fullWidth={fullWidth}      
      onChange={onInputChanged}
      onBlur={field.onBlur}  
      size="small"
      value={field.value}     
      renderInput={(params) => (
        <TextField
          {...params}
          label="Vorhabenträger"
          slotProps={{
            htmlInput: {
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            },
          }}
        />
      )}
    />  
     {meta.error ? (
        <FormHelperText>{meta.error}</FormHelperText>
      ) : (
        <div css={helperTextPlaceHolderStyle} />
      )} 
    </FormControl>
  )
}

export default AutoListbox
